export const retardColumns = [
    { key: 'id', label: 'ID', class: 'text-center' },
    { key: 'achevement', label: 'Achèvement', class: 'text-wrap' },
    { key: 'causesRetard', label: 'Causes de Retard', class: 'text-wrap' },
    { key: 'structureResp', label: 'Structure Responsable', class: 'text-wrap' },
    { key: 'difficultes', label: 'Difficultés', class: 'text-wrap' },
    { key: 'solutions', label: 'Solutions', class: 'text-wrap' },
    { key: 'eligibleRpt', label: 'Eligible RPT', class: 'text-center' },
    { key: 'dateMaj', label: 'Date de Mise à Jour', class: 'text-nowrap' },
    { key: 'actions', label: 'Action', class: 'text-center' }
];

export const retardFilterableFields = [
    { key: 'id', label: 'ID', type: 'text', placeholder: 'Entrer un ID' },
    { key: 'achevement', label: 'Achèvement', type: 'text', placeholder: 'Filtrer par achèvement' },
    { key: 'causesRetard', label: 'Causes de Retard', type: 'text', placeholder: 'Filtrer par cause' },
    { key: 'structureResp', label: 'Structure Responsable', type: 'text', placeholder: 'Filtrer par structure' },
    { key: 'eligibleRpt', label: 'Eligible RPT', type: 'text', placeholder: 'Oui / Non' }
];

export const retardRowActions = [
    { name: 'edit', event: 'edit', icon: 'fe fe-edit fs-18 text-primary' },
    { name: 'drop', event: 'drop', icon: 'fe fe-trash-2 fs-18 text-danger' }
];

export const  livrableColumns = [
    { key: 'id', label: 'ID', class: 'text-center' },
    { key: 'type', label: 'Type', class: 'text-nowrap' },
    { key: 'referencePmo', label: 'Référence PMO', class: 'text-nowrap' },
    { key: 'pointFocalAbin', label: 'Point Focal ABIN', class: 'text-nowrap' },
    { key: 'pole', label: 'POLE', class: 'text-nowrap' },
    { key: 'entiteChargee', label: 'Entité chargée', class: 'text-nowrap' },
    { key: 'description', label: 'Description', class: 'text-wrap' },
    { key: 'lot', label: 'Lot', class: 'text-nowrap' },
    { key: 'actions', label: 'Action', class: 'text-center' }
]
export const  livrableRowActions = [
    { name: 'edit', event: 'edit', icon: 'fe fe-edit fs-18 text-primary' },
    { name: 'drop', event: 'drop', icon: 'fe fe-trash-2 fs-18 text-danger' },
];
export const  livrableFilterableFields = [
    { key: 'id', label: 'ID', type: 'text', placeholder: 'Entrer l’ID' },
    { key: 'type', label: 'Type', type: 'text', placeholder: 'Entrer le type' },
    { key: 'referencePmo', label: 'Référence PMO', type: 'text', placeholder: 'Entrer une référence' },
    { key: 'pointFocalAbin', label: 'Point Focal ABIN', type: 'text', placeholder: 'Nom du point focal' },
    { key: 'pole', label: 'POLE', type: 'text', placeholder: 'Entrer le pôle' },
    { key: 'entiteChargee', label: 'Entité chargée', type: 'text', placeholder: 'Entrer une entité' },
    { key: 'lot', label: 'Lot', type: 'text', placeholder: 'Nom du lot' }
];
export const pointDurColumns = [
    { key: 'id', label: 'ID', class: 'text-center' },
    { key: 'description', label: 'Description', class: 'text-wrap' },
    { key: 'mesuresGestion', label: 'Mesures de gestion', class: 'text-wrap' },
    { key: 'actionAttendu', label: 'Action attendue', class: 'text-wrap' },
    { key: 'dateMaj', label: 'Date de mise à jour', class: 'text-nowrap' },
    { key: 'actions', label: 'Action', class: 'text-center' }
];
export const  pointDurFilterableFields = [
    { key: 'id', label: 'ID', type: 'text', placeholder: 'Entrer l’ID' },
    { key: 'description', label: 'Description', type: 'text', placeholder: 'Filtrer par description' },
    { key: 'mesuresGestion', label: 'Mesures de gestion', type: 'text', placeholder: 'Filtrer par mesures' },
    { key: 'actionAttendu', label: 'Action attendue', type: 'text', placeholder: 'Filtrer par action' }
];
export const  pointDurRowActions = [
    { name: 'edit', event: 'edit', icon: 'fe fe-edit fs-18 text-primary' },
    { name: 'drop', event: 'drop', icon: 'fe fe-trash-2 fs-18 text-danger'}
];
export const risqueColumns = [
    { key: 'id', label: 'ID', class: 'text-center' },
    { key: 'owner', label: 'Owner', class: 'text-nowrap' },
    { key: 'reponseGestion', label: 'Réponse de Gestion', class: 'text-wrap' },
    { key: 'delaiJrs', label: 'Délai (jours)', class: 'text-center' },
    { key: 'dateMaj', label: 'Date de Mise à Jour', class: 'text-nowrap' },
    { key: 'actions', label: 'Action', class: 'text-center' }
];

export const risqueFilterableFields = [
    { key: 'id', label: 'ID', type: 'text', placeholder: 'Entrer un ID' },
    { key: 'owner', label: 'Owner', type: 'text', placeholder: 'Filtrer par owner' },
    { key: 'reponseGestion', label: 'Réponse de Gestion', type: 'text', placeholder: 'Filtrer par réponse' },
    { key: 'delaiJrs', label: 'Délai (jours)', type: 'number', placeholder: 'Filtrer par délai' }
];

export const risqueRowActions = [
    { name: 'edit', event: 'edit', icon: 'fe fe-edit fs-18 text-primary' },
    { name: 'drop', event: 'drop', icon: 'fe fe-trash-2 fs-18 text-danger' }
];
